/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_Gone_TitleInputs */



/**
* | output |
* | --- |
* | "This invitation no longer works" |
*
* @param {Invite_X15_Gone_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_gone_title = /** @type {((inputs?: Invite_X15_Gone_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Gone_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This invitation no longer works")
});